import React from 'react';
import Avatar from 'components/Avatar';
import AvatarWithText from 'components/AvatarWithText';
import Text from 'components/Text';
import { getCoachTitle } from 'coaching/lib/nameFormat';
import CoachingAvatar from 'assets/images/coaching/coaching_avatar.svg';

type Props = {
  subjectName?: string;
  coachFullName?: string;
};

export default function CoachAvatarWithSubject({ subjectName, coachFullName }: Props) {
  return (
    <AvatarWithText
      title={
        <Text size="medium" lineHeight="flush">
          {subjectName ?? 'Remind Tutoring'}
        </Text>
      }
      subtext={
        coachFullName ? <Text size="xsmall">with {getCoachTitle(coachFullName)}</Text> : undefined
      }
      avatar={
        <Avatar
          color="grey"
          serif
          text={coachFullName?.slice(0, 1)}
          image={coachFullName ? undefined : CoachingAvatar}
        />
      }
      avatarSize="large"
      subtle
    />
  );
}
